import styled from 'styled-components';
import { withAlpha } from '../../util/color.util';

export const List = styled.ul`
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  overflow-y: scroll !important;

  > li {
    padding: 4px 8px;
    background: white;

    @media (max-width: 1000px) {
      padding: 2px 4px;

      span {
        font-size: 12px;
        text-overflow: ellipsis;
      }
    }
  }

  > li:nth-child(2n) {
    background: ${(props: any) =>
      withAlpha(props.theme.colors.primaryColor, 0.05)};
  }
`;
